import { render } from "./Inspector.vue?vue&type=template&id=4689ba46"
import script from "./Inspector.vue?vue&type=script&lang=js"
export * from "./Inspector.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__